/*global VeloxViewController, VeloxWebView*/

var viewsTree = require("../../views_tree.json") ;

var helpController = new VeloxViewController({
    directory : "views/help",
    name: "helpOnePage",
    route: "help-one-page"
}) ;

function flattenEntry(entries, entry, level){
    entry.level = level;
    entry.hasChildren = !!entry.children;
    if(!entry.hasChildren && !/\.md$/.test(entry.name)){
        return ;
    }
    entry.path = entry.path.replace(/\\/g, "/") ;
    entry.fullpath = entry.path.replace(/^src\//, "") ;
    entry.path = entry.path.replace(/^src\//, "").replace("/"+entry.name, "") ;
    entry.filename = entry.name.replace(/\.md$/, "") ;
    entry.name = entry.name.replace(/\.md$/, "").replace(/^[0-9]{2}-/, "").replace("+", ";") ;
    entries.push(entry) ;
    if(entry.children){
        entry.children.forEach(function(c){
            flattenEntry(entries, c, level+1) ;
        }) ;
    }
}

helpController.prepareDataOnEnter = function(dataQuery, callback){
    var isIos = false;
    var nP = navigator.platform;      
    if (nP == "iPad" || nP == "iPhone" || nP == "iPod" || nP == "iPhone Simulator" || nP == "iPad Simulator"){
        isIos = true;
    }
    var pageId = dataQuery;
    var data = {} ;
    var lang = VeloxWebView.i18n.getLang().substring(0,2) ;
    data.flatHierarchy = [];
    data.isIos = isIos ;
    
    var helpEntries = viewsTree.children.filter(function(c){ return c.name === "help" ;}) ;
    helpEntries = JSON.parse(JSON.stringify(helpEntries)) ;
    console.log("helpEntries ?", helpEntries) ;
    if(helpEntries.length > 0){
        var helpEntry = helpEntries[0] ;
        var mdEntries = helpEntry.children.filter(function(c){ return c.name === "markdown" ;}) ;
        if(mdEntries.length > 0){
            var mdEntry = mdEntries[0] ;
            var frEntries = mdEntry.children.filter(function(c){ return c.name === lang ;}) ;
            if(frEntries.length > 0){
                var frEntry = frEntries[0] ;
                frEntry.children.forEach(function(c){
                    flattenEntry(data.flatHierarchy, c, 0) ;
                }) ;
            }
        }
    }
    var basePath = "views/help/markdown/fr/" ;
    data.basePath = basePath;
    if(pageId){
        var pagePath = basePath+pageId+".md" ;
        data.flatHierarchy.some(function(entry){
            if(entry.fullpath.replace(/\\/g, "/") === pagePath){
                entry.selected = true ;
                data.selectedEntry = entry;
                return true ;
            }
        }) ;
    }

    console.log("data ?", data) ;

    callback(null, data) ;
};


helpController.onRender = function(){
    this.view.ensureDisplayed(function(){
        this.data.flatHierarchy.filter(function(e){ return !e.hasChildren ;}).forEach(function(entry){
            var div = document.createElement("DIV") ;
            this.view.EL.contents.appendChild(div) ;
            var view = new VeloxWebView(entry.path, entry.filename, {container: div}) ;
            view.open()  ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = helpController ;